/* PBA Fight Club Hub. All state, selectors and listeners are scoped to each .pba-hub section root. */
(function () {
  'use strict';

  // Singleton runtime: the section can render its <script> several times (one per instance).
  // Only the first evaluation registers document lifecycle listeners; later ones just rescan.
  if (window.__pbaHubRuntime) { window.__pbaHubRuntime.scan(document); return; }

  var instances = new WeakMap();
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function embedUrl(url) {
    var m;
    if (/youtube\.com|youtu\.be/.test(url)) {
      m = url.match(/youtu\.be\/([\w-]{6,})/) || url.match(/[?&]v=([\w-]{6,})/) ||
        url.match(/\/(?:embed|shorts|live)\/([\w-]{6,})/);
      return m ? 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0' : null;
    }
    if (/vimeo\.com/.test(url)) {
      m = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
      return m ? 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' : null;
    }
    return null;
  }

  function init(root) {
    if (instances.has(root)) return;
    var cleanups = [];
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    function on(el, type, fn, opts) {
      el.addEventListener(type, fn, opts);
      cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    root.classList.add('pba-hub--js');
    var panels = qa('[data-pba-panel]');
    var navItems = qa('[data-pba-nav]');
    var panelNav = navItems.filter(function (n) { return n.getAttribute('data-panel-key'); });
    var currentKey = null;
    var rankingsFrame = q('[data-pba-rankings]');
    var rankingsOrigin = null;
    if (rankingsFrame) {
      try { rankingsOrigin = new URL(rankingsFrame.getAttribute('data-src'), location.href).origin; } catch (err) { rankingsOrigin = null; }
      on(window, 'message', function (e) {
        // Accept height updates only from this frame and its configured app origin.
        if (!rankingsOrigin || e.origin !== rankingsOrigin || e.source !== rankingsFrame.contentWindow) return;
        var data = e.data;
        if (!data || data.type !== 'pba-rankings:resize' || typeof data.height !== 'number' || !Number.isFinite(data.height)) return;
        if (data.height < 1 || data.height > 50000) return;
        rankingsFrame.style.height = Math.max(360, Math.ceil(data.height)) + 'px';
      });
    }

    function activate(key, focusNav) {
      var found = panels.some(function (p) { return p.getAttribute('data-pba-panel') === key; });
      if (!found) key = panels.length ? panels[0].getAttribute('data-pba-panel') : null;
      currentKey = key;
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-pba-panel') !== key; });
root.dispatchEvent(new CustomEvent('pba:panel:change', { detail: { key: key } }));
      if (key === 'rankings' && rankingsFrame) {
        rankingsFrame.hidden = false;
        if (!rankingsFrame.getAttribute('src')) rankingsFrame.setAttribute('src', rankingsFrame.getAttribute('data-src'));
      }
      panelNav.forEach(function (n) {
        var active = n.getAttribute('data-panel-key') === key;
        if (active) n.setAttribute('aria-current', 'page'); else n.removeAttribute('aria-current');
        n.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focusNav) n.focus();
      });
    }

    function activeNavEl() {
      return panelNav.filter(function (n) { return n.getAttribute('data-panel-key') === currentKey; })[0];
    }
    function revealNav(el) {
      if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
    }

    navItems.forEach(function (n) {
      var key = n.getAttribute('data-panel-key');
      if (key) {
        on(n, 'click', function (e) {
          e.preventDefault();
          activate(key);
          if (window.history && history.replaceState) history.replaceState(null, '', '#' + n.getAttribute('href').slice(1));
        });
      }
      if (!key) return;
      on(n, 'keydown', function (e) {
        var i = panelNav.indexOf(n), t = null;
        if (e.key === 'ArrowRight') t = panelNav[(i + 1) % panelNav.length];
        else if (e.key === 'ArrowLeft') t = panelNav[(i - 1 + panelNav.length) % panelNav.length];
        else if (e.key === 'Home') t = panelNav[0];
        else if (e.key === 'End') t = panelNav[panelNav.length - 1];
        if (t) {
          e.preventDefault();
          panelNav.forEach(function (x) { x.setAttribute('tabindex', x === t ? '0' : '-1'); });
          t.focus();
          revealNav(t);
        }
      });
    });
    qa('[data-pba-goto]').forEach(function (a) {
      on(a, 'click', function (e) { e.preventDefault(); activate(a.getAttribute('data-pba-goto')); });
    });

    // Initial panel: hash, then page param (directory pagination), then first nav panel.
    var hashId = (location.hash || '').slice(1);
    var initial = null;
    panels.forEach(function (p) { if (hashId && p.id === hashId) initial = p.getAttribute('data-pba-panel'); });
    var dirEl = q('[data-pba-directory]');
    var pageParam = (dirEl && dirEl.getAttribute('data-page-param')) || 'page';
    if (!initial && dirEl && new RegExp('[?&]' + pageParam + '=\\d+').test(location.search)) initial = 'barbers';
    if (!initial && panelNav[0]) initial = panelNav[0].getAttribute('data-panel-key');
    activate(initial);
on(window, 'hashchange', function () {
  var targetId = (location.hash || '').slice(1);
  panels.forEach(function (p) {
    if (p.id === targetId) activate(p.getAttribute('data-pba-panel'));
  });
});

    // Row arrows
    qa('[data-pba-scroll]').forEach(function (b) {
      on(b, 'click', function () {
        var row = b.closest('[data-pba-row]');
        var track = row && row.querySelector('[data-pba-track]');
        if (track) track.scrollBy({ left: Number(b.getAttribute('data-pba-scroll')) * track.clientWidth * 0.85, behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });

    // Media dialog (YouTube / Vimeo only)
    var dialog = null, lastTrigger = null;
    function getDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.className = 'pba-hub__dialog';
      dialog.setAttribute('aria-label', 'Video player');
      dialog.innerHTML = '<button type="button" class="pba-btn pba-btn--light pba-hub__dialog-close">Close</button><div class="pba-hub__dialog-frame"></div>';
      root.appendChild(dialog);
      on(dialog.querySelector('button'), 'click', function () { dialog.close(); });
      on(dialog, 'close', function () {
        dialog.querySelector('.pba-hub__dialog-frame').innerHTML = '';
        if (lastTrigger) lastTrigger.focus();
      });
      on(dialog, 'click', function (e) { if (e.target === dialog) dialog.close(); });
      return dialog;
    }
    on(root, 'click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-pba-media]') : null;
      if (!t || !root.contains(t)) return;
      var url = t.getAttribute('data-pba-media');
      var src = embedUrl(url);
      if (!src || typeof HTMLDialogElement === 'undefined') { window.open(url, '_blank', 'noopener'); return; }
      var d = getDialog();
      lastTrigger = t;
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = 'Video player';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      d.querySelector('.pba-hub__dialog-frame').appendChild(iframe);
      d.showModal();
    });

    // Theme editor: select a block, show its panel.
    on(root, 'shopify:block:select', function (e) {
      var el = e.target;
      var nav = el.querySelector && el.querySelector('[data-panel-key]');
      var panel = el.closest && el.closest('[data-pba-panel]');
      if (nav) activate(nav.getAttribute('data-panel-key'));
      else if (panel) activate(panel.getAttribute('data-pba-panel'));
      revealNav(activeNavEl());
    });

    initDirectory();

    function initDirectory() {
      var dir = q('[data-pba-directory]');
      if (!dir) return;
      var grid = dir.querySelector('[data-pba-grid]');
      var form = dir.querySelector('[data-pba-search-form]');
      var input = dir.querySelector('[data-pba-search]');
      var status = dir.querySelector('[data-pba-status]');
      var retryWrap = dir.querySelector('[data-pba-retry-wrap]');
      var retryBtn = dir.querySelector('[data-pba-retry]');
      var empty = dir.querySelector('[data-pba-empty]');
      var moreWrap = dir.querySelector('[data-pba-more-wrap]');
      var moreBtn = dir.querySelector('[data-pba-more]');
      var pager = dir.querySelector('[data-pba-pager]');
      var pages = Number(dir.getAttribute('data-pages')) || 1;
      var current = Number(dir.getAttribute('data-current')) || 1;
      var pageParam = dir.getAttribute('data-page-param') || 'page';
      var pathOverride = dir.getAttribute('data-page-path');
      var sectionId = root.getAttribute('data-section-id');
      var STEP = 48, limit = STEP;
      var seen = Object.create(null), cards = [];
      var pending = [];
      for (var p = 1; p <= pages; p++) if (p !== current) pending.push(p);
      var loading = false, failed = false;

      form.hidden = false;
      status.hidden = false;
      on(form, 'submit', function (e) { e.preventDefault(); });

      function register(el) {
        var key = el.getAttribute('data-key') || String(cards.length);
        if (seen[key]) return false;
        seen[key] = true;
        cards.push(el);
        return true;
      }
      qa('[data-pba-directory] [data-pba-barber]').forEach(register);

      function done() { return pending.length === 0 && !failed; }

      function render() {
        var term = (input.value || '').trim().toLowerCase();
        var shown = 0, matched = 0;
        cards.forEach(function (c) {
          var hit = !term || (c.getAttribute('data-search') || '').indexOf(term) !== -1;
          if (hit) matched++;
          var vis = hit && shown < limit;
          if (vis) shown++;
          c.hidden = !vis;
        });
        moreWrap.hidden = matched <= shown;
        if (!moreWrap.hidden) moreBtn.textContent = 'Show more barbers (' + (matched - shown) + ' left)';
        retryWrap.hidden = !failed;
        empty.hidden = !(matched === 0 && done() && cards.length > 0);
        if (failed) status.textContent = 'Could not load the full directory. Search covers ' + cards.length + ' barbers so far.';
        else if (!done()) {
          status.textContent = 'Indexing the directory: ' + cards.length + ' barbers loaded, ' + pending.length + (pending.length === 1 ? ' page' : ' pages') + ' to go.' +
            (term && matched === 0 ? ' Still searching, no match yet.' : '');
        } else {
          status.textContent = term ? matched + ' of ' + cards.length + ' barbers match.' : cards.length + ' barbers.';
          if (pager) pager.hidden = true;
        }
      }

      function fetchPage(n) {
        // Keep the current query (preview_theme_id, view, locale...) and swap only the page + section id.
        var u = new URL(pathOverride ? pathOverride.replace('__PAGE__', n) : location.href, location.href);
        if (!pathOverride) { u.search = location.search; u.hash = ''; }
        u.searchParams.set(pageParam, n);
        u.searchParams.set('section_id', sectionId);
        var url = u.toString();
        return fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var scope = doc.querySelector('.pba-hub[data-section-id="' + sectionId + '"]');
            var remoteDir = scope && scope.querySelector('[data-pba-directory]');
            if (!remoteDir || !remoteDir.querySelector('[data-pba-grid]')) throw new Error('Section response has no directory');
            if (Number(remoteDir.getAttribute('data-current')) !== n) throw new Error('Unexpected page returned');
            Array.prototype.forEach.call(remoteDir.querySelectorAll('[data-pba-barber]'), function (c) {
              var node = document.importNode(c, true);
              if (register(node)) grid.appendChild(node);
            });
          });
      }

      function run() {
        if (loading) return;
        loading = true; failed = false;
        render();
        (function next() {
          if (!pending.length) { loading = false; render(); return; }
          var n = pending[0];
          fetchPage(n).then(function () { pending.shift(); render(); next(); })
            .catch(function (err) {
              loading = false;
              if (err && err.name === 'AbortError') return;
              failed = true; render();
            });
        })();
      }

      on(input, 'input', function () { limit = STEP; render(); });
      on(moreBtn, 'click', function () { limit += STEP; render(); });
      on(retryBtn, 'click', run);
      run();
    }

    instances.set(root, {
      destroy: function () {
        if (controller) controller.abort();
        cleanups.forEach(function (fn) { fn(); });
        if (dialog && dialog.parentNode) dialog.parentNode.removeChild(dialog);
        root.classList.remove('pba-hub--js');
        instances.delete(root);
      }
    });
  }

  function scan(scope) {
    var roots = scope.matches && scope.matches('.pba-hub') ? [scope] : [];
    Array.prototype.push.apply(roots, scope.querySelectorAll ? scope.querySelectorAll('.pba-hub') : []);
    roots.forEach(init);
  }
  function teardown(scope) {
    var roots = scope.matches && scope.matches('.pba-hub') ? [scope] : [];
    Array.prototype.push.apply(roots, scope.querySelectorAll ? scope.querySelectorAll('.pba-hub') : []);
    roots.forEach(function (r) { var i = instances.get(r); if (i) i.destroy(); });
  }

  window.__pbaHubRuntime = { scan: scan, teardown: teardown };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
